"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Indeterminate = exports.Checked = exports.Unchecked = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _v = _interopRequireDefault(require("uuid/v4"));

var _colors = require("../colors");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/* eslint-disable react/jsx-curly-brace-presence */
var Unchecked =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Unchecked, _PureComponent);

  function Unchecked() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, Unchecked);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Unchecked)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "uniqueId", (0, _v["default"])());

    return _this;
  }

  _createClass(Unchecked, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          width = _this$props.width,
          color = _this$props.color,
          backgroundColor = _this$props.backgroundColor;
      return _react["default"].createElement("svg", {
        name: "unchecked",
        width: width,
        height: width,
        viewBox: "0 0 24 24"
      }, _react["default"].createElement("defs", null, _react["default"].createElement("path", {
        id: this.uniqueId,
        d: "M0,2.38895416 C0,1.06957121 1.07785486,0 2.38895416,0 L21.6110458,0 C22.9304288,0 24,1.07785486 24,2.38895416 L24,\n            21.6110458 C24,22.9304288 22.9221451,24 21.6110458,24 L2.38895416,24 C1.06957121,24 0,22.9221451 0,21.6110458 L0,\n            2.38895416 Z M2.4,21.6 L21.6,21.6 L21.6,2.4 L2.4,2.4 L2.4,21.6 Z"
      })), _react["default"].createElement("g", {
        fill: "none",
        fillRule: "evenodd"
      }, _react["default"].createElement("rect", {
        x: "0",
        y: "0",
        width: "24",
        height: "24",
        rx: "3",
        stroke: "black",
        strokeWidth: "0",
        fill: backgroundColor
      }), _react["default"].createElement("use", {
        fill: color,
        xlinkHref: "#".concat(this.uniqueId)
      })));
    }
  }]);

  return Unchecked;
}(_react.PureComponent);

exports.Unchecked = Unchecked;
Unchecked.propTypes = {
  width: _propTypes["default"].string,
  color: _propTypes["default"].string,
  backgroundColor: _propTypes["default"].string
};
Unchecked.defaultProps = {
  width: '16px',
  color: _colors.cobalt.base,
  backgroundColor: 'none'
};

var Checked =
/*#__PURE__*/
function (_PureComponent2) {
  _inherits(Checked, _PureComponent2);

  function Checked() {
    var _getPrototypeOf3;

    var _this2;

    _classCallCheck(this, Checked);

    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    _this2 = _possibleConstructorReturn(this, (_getPrototypeOf3 = _getPrototypeOf(Checked)).call.apply(_getPrototypeOf3, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this2), "uniqueId", (0, _v["default"])());

    return _this2;
  }

  _createClass(Checked, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          width = _this$props2.width,
          color = _this$props2.color,
          backgroundColor = _this$props2.backgroundColor;
      return _react["default"].createElement("svg", {
        name: "checked",
        width: width,
        height: width,
        viewBox: "0 0 24 24"
      }, _react["default"].createElement("defs", null, _react["default"].createElement("path", {
        id: "".concat(this.uniqueId, "-a"),
        d: "M0,1 L0,23 C0,23.5522847 0.44771525,24 1,24 L23,24 C23.5522847,24 24,23.5522847 24,23 L24,\n            1 C24,0.44771525 23.5522847,0 23,0 L1,0 C0.44771525,0 0,0.44771525 0,1 Z"
      })), _react["default"].createElement("g", {
        fill: "none",
        fillRule: "evenodd"
      }, _react["default"].createElement("rect", {
        x: "0",
        y: "0",
        width: "24",
        height: "24",
        rx: "2",
        stroke: "black",
        strokeWidth: "0",
        fill: backgroundColor
      }), _react["default"].createElement("mask", {
        id: "".concat(this.uniqueId, "-b"),
        fill: "#fff"
      }, _react["default"].createElement("use", {
        xlinkHref: "#".concat(this.uniqueId, "-a")
      })), _react["default"].createElement("g", {
        fill: color,
        mask: "url(#".concat(this.uniqueId, "-b)")
      }, _react["default"].createElement("rect", {
        width: "24",
        height: "24"
      })), _react["default"].createElement("g", {
        fill: "#FFF",
        mask: "url(#".concat(this.uniqueId, "-b)")
      }, _react["default"].createElement("path", {
        d: "M14.7060415,0.294045226 C14.314157,-0.0980276382 13.711142,-0.0980276382 13.3190691,0.294045226 L5.11817714,\n              8.49493719 L1.68102889,5.08797739 C1.28895603,4.69609296 0.685940955,4.69609296 0.294056533,5.08797739 C-0.0980163317,\n              5.47986181 -0.0980163317,6.08287688 0.294056533,6.47494975 L4.42459673,10.5754899 C4.60553894,10.7562437 4.87685804,\n              10.8769975 5.11817714,10.8769975 C5.35930779,10.8769975 5.63062688,10.7562437 5.8115691,10.5754899 L14.7060415,\n              1.71101759 C15.0981143,1.31913317 15.0981143,0.685929648 14.7060415,0.294045226",
        transform: "translate(4.5 6.75)"
      }))));
    }
  }]);

  return Checked;
}(_react.PureComponent);

exports.Checked = Checked;
Checked.propTypes = {
  width: _propTypes["default"].string,
  color: _propTypes["default"].string,
  backgroundColor: _propTypes["default"].string
};
Checked.defaultProps = {
  width: '16px',
  color: _colors.teal.base,
  backgroundColor: 'none'
};

var Indeterminate =
/*#__PURE__*/
function (_PureComponent3) {
  _inherits(Indeterminate, _PureComponent3);

  function Indeterminate() {
    var _getPrototypeOf4;

    var _this3;

    _classCallCheck(this, Indeterminate);

    for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      args[_key3] = arguments[_key3];
    }

    _this3 = _possibleConstructorReturn(this, (_getPrototypeOf4 = _getPrototypeOf(Indeterminate)).call.apply(_getPrototypeOf4, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this3), "uniqueId", (0, _v["default"])());

    return _this3;
  }

  _createClass(Indeterminate, [{
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          width = _this$props3.width,
          color = _this$props3.color,
          backgroundColor = _this$props3.backgroundColor;
      return _react["default"].createElement("svg", {
        name: "indeterminate",
        width: width,
        height: width,
        viewBox: "0 0 24 24"
      }, _react["default"].createElement("defs", null, _react["default"].createElement("path", {
        id: "".concat(this.uniqueId, "-a"),
        d: "M0,1 L0,23 C0,23.5522847 0.44771525,24 1,24 L23,24 C23.5522847,24 24,23.5522847 24,23 L24,1 C24,0.44771525 23.5522847,\n            0 23,0 L1,0 C0.44771525,0 0,0.44771525 0,1 Z M16.8,12.9 C17.4627417,12.9 18,12.3627417 18,11.7 C18,11.0372583 17.4627417,\n            10.5 16.8,10.5 L7.2,10.5 C6.5372583,10.5 6,11.0372583 6,11.7 C6,12.3627417 6.5372583,12.9 7.2,12.9 L16.8,12.9 Z"
      })), _react["default"].createElement("g", {
        fill: "none",
        fillRule: "evenodd"
      }, _react["default"].createElement("rect", {
        x: "0",
        y: "0",
        width: "24",
        height: "24",
        rx: "2",
        stroke: "black",
        strokeWidth: "0",
        fill: backgroundColor
      }), _react["default"].createElement("mask", {
        id: "".concat(this.uniqueId, "-b"),
        fill: "#fff"
      }, _react["default"].createElement("use", {
        xlinkHref: "#".concat(this.uniqueId, "-a")
      })), _react["default"].createElement("g", {
        fill: color,
        mask: "url(#".concat(this.uniqueId, "-b)")
      }, _react["default"].createElement("rect", {
        width: "24",
        height: "24"
      }))));
    }
  }]);

  return Indeterminate;
}(_react.PureComponent);

exports.Indeterminate = Indeterminate;
Indeterminate.propTypes = {
  width: _propTypes["default"].string,
  color: _propTypes["default"].string,
  backgroundColor: _propTypes["default"].string
};
Indeterminate.defaultProps = {
  width: '16px',
  color: _colors.teal.base,
  backgroundColor: 'none'
};